export const JOB_AD_ASSIGNMENT_HINT =
  "Published. Assign this job ad to a career site on Home to make it available in your ATS.";

export const publishNotice = (
  isJobAd: boolean,
  addedToPs: boolean | undefined
): string | null =>
  isJobAd && addedToPs === false ? JOB_AD_ASSIGNMENT_HINT : null;
